module.exports = __webpack_public_path__ + "img/emoji_24.7f593de5.png";